// extracted by mini-css-extract-plugin
module.exports = {"desktop_image":"styles_desktop_image__NbYYx","mobile_image":"styles_mobile_image__d8OqC","fade-out":"styles_fade-out__iQ7Iy","fade-in":"styles_fade-in__i8QVq"};